// markKeyAsUsed.js
import getFetchOptions from '../utils/getFetchOptions';
import { ENDPOINT_URL } from '../constants/index';

export default async function markKeyAsUsed({ signal } = {}) {
  const res = await fetch(
    `${ENDPOINT_URL}/test/markkeycustom`,
    getFetchOptions({ method: 'POST', signal }) // ensure this sets Authorization
  );

  // Try to parse JSON if sent back
  const contentType = res.headers.get('content-type') || '';
  let payload = null;
  if (contentType.includes('application/json')) {
    try {
      payload = await res.json();
    } catch {
      // ignore parse errors; payload stays null
    }
  }

  if (!res.ok) {
    const detail =
      (payload && (payload.error || payload.message)) ||
      (await res.text().catch(() => '')) ||
      'Unknown error';

    const err = new Error(`markKeyAsUsed failed: ${res.status} ${detail}`);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }

  // e.g. { message: 'Submitted test info successfully' }
  return payload;
}
